import * as MessagesActionTypes from 'actiontypes/messages';
import MessagesService from 'services/MessagesService';
import { Dispatch } from 'redux';

const messagesService = new MessagesService();

const deleteRequested = () => ({
  type: MessagesActionTypes.DELETE_REQUESTED,
});

const deleteSuccess = (messageId: number) => ({
  type: MessagesActionTypes.DELETE_SUCCESS,
  payload: messageId,
});

const deleteFailure = (error: any) => ({
  type: MessagesActionTypes.DELETE_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * DELETE A MESSAGE
 -----------------------------------------------------------------------------*/
export default function deleteMessage(messageId: number) {
  return async (dispatch: Dispatch) => {
    dispatch(deleteRequested());
    try {
      await messagesService.deleteMessage(messageId);
      dispatch(deleteSuccess(messageId));
    } catch (error) {
      dispatch(deleteFailure(error));
    }
  };
}